import React, { useState, useEffect } from 'react'
import IconButton from '@material-ui/core/IconButton'
import DeleteForever from '@material-ui/icons/DeleteForever'
import Button from '@material-ui/core/Button'

import DeleteForm from '../Forms/Delete'
import Details from '../Displays/Detail'
import useMediaPath from 'hooks/useMediaPath'
import styles from '../environment.module.scss'
import PreviewComponent from 'components/Global/Preview'

const Environment = ({ update, data, loading }) => {
  const [environment, setEnvironment] = useState(data)
  const [deleteForm, setDeleteForm] = useState(false)
  const [envId, setEnvId] = useState()
  const [details, setDetails] = useState(false)

  const mediaPath = useMediaPath()

  return (
    <div className={styles.content}>
      {environment.map((env, i) => {
        return (
          <div key={env.id}>
            <PreviewComponent
              title={env.name}
              preview={mediaPath(env.panoThumb)}
              componentType="thumbnail"
              previewSize={[250, 150]}
              actions={[
                <Button
                  onClick={() => {
                    setDetails(true)
                    setEnvId(i)
                  }}
                  key={2}
                >
                  detail
                </Button>,
                // <IconButton
                //   color="secondary"
                //   onClick={() => {
                //     setEnvId(i)
                //     setEditForm(true)
                //   }}
                // >
                //   <Edit />
                // </IconButton>,
                <IconButton
                  color="secondary"
                  onClick={() => {
                    setEnvId(i)
                    setDeleteForm(true)
                  }}
                  key={1}
                >
                  <DeleteForever />
                </IconButton>,
              ]}
            />
          </div>
        )
      })}
      {deleteForm && (
        <DeleteForm
          open={deleteForm}
          setOpen={setDeleteForm}
          env={environment[envId]}
          update={update}
          loading={loading}
        />
      )}
      {/* {editForm && (
        <EditForm
          open={editForm}
          setOpen={setEditForm}
          env={environment[envId]}
          update={setUpdate}
          loading={setLoading}
        />
      )} */}
      {details && (
        <Details open={details} setOpen={setDetails} env={environment[envId]} />
      )}
    </div>
  )
}

export default Environment
